<router-outlet></router-outlet>

<ngx-spinner
bdOpacity = 0.9
bdColor = "rgba(0,0,0,0.4)"
size = "large"
color = "#00aeff"
type = "ball-clip-rotate-pulse"
[fullScreen] = "true"
class="loader_container"
>
<p style="color: white" > </p>
</ngx-spinner>